const LANGUAGE_FALLBACKS = {
    'no-NO': 'nb-NO',
    no: 'nb'
};
const localeLikePattern = /^([a-zA-Z]{2,3})(?:[-_]+([a-zA-Z]{2}|[0-9]{3}))?(?:[-_]+([a-zA-Z]+))?$/;
const isLocaleLike = (locale) => !!locale && localeLikePattern.test(locale);

const getRegionPart = (locale) => {
    let [, , region] = localeLikePattern.exec(locale);
    if (region) {
        region = region.toLowerCase();
    }
    return region;
};

// react-intl and google maps expect a different locale format from the standard
// ex. "en-US" or "en"
// "no" locale is not valid language, we have to use "nb" instead
export function formatLocale(locale) {
    const langCountryPair = locale.match(/^.{2}_.{2}/);
    let formattedLocale = locale.slice(0, 2);

    if (langCountryPair) {
        formattedLocale = langCountryPair[0].replace('_', '-');
    }

    return LANGUAGE_FALLBACKS[formattedLocale] || formattedLocale;
}

// returns correct language from locale
export function getLanguageFromLocale(locale) {
    if (locale) {
        return formatLocale(locale).split(/_|-/)[0];
    }
    return null;
}

// returns correct region from locale
export function getRegion(locale) {
    if (isLocaleLike(locale)) {
        return getRegionPart(locale);
    }

    return null;
}
